import RelatedSearches from 'components/RelatedSearches/RelatedSearches.f';

export default RelatedSearches;
